const i = {
  name: "WarningCircleFill",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM13 7H11V13H13V7ZM12 17.25C12.69 17.25 13.25 16.69 13.25 16C13.25 15.31 12.69 14.75 12 14.75C11.31 14.75 10.75 15.31 10.75 16C10.75 16.69 11.31 17.25 12 17.25Z" fill="currentColor"/>
</svg>
  `
};
export {
  i as WarningCircleFill
};
